import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8f708017: FaireBrandEntity = {
  token: "b_8f708017",
  type: "brand",
  name: "Yellow Owl Workshop",
  avatarUrl:
    "https://cdn.faire.com/fastly/e4fad344c89df4cf1a4a4895f1c44e0879b29cb618e9a14bda311424106e3ee7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/48008efcc92de556eb5b958d019624e17339e51b29036afee9ecf960b62eb9cf.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e4fad344c89df4cf1a4a4895f1c44e0879b29cb618e9a14bda311424106e3ee7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/48008efcc92de556eb5b958d019624e17339e51b29036afee9ecf960b62eb9cf.png",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 175,
  isTopShop: true,
  isInsider: true,
  description:
    "Yellow Owl Workshop is a collection of artful, unique goods for creative expression designed by artist & author Christine Schmidt. Notable for its sophisticated yet playful aesthetic, the range of products includes greeting cards, a line of exquisite enamel gold pendants, earrings, lapel pins and rings, socks and craft kits.\n\nThough the products are diverse, consistent themes of innovative function, original graphics and bold colors emerge. \nEach item is expertly crafted with attention to detail, ecological awareness and premium materials.\n\n🌈 Fun things to craft, wear, share\n🌲 Mama Earth-lovin’ goods\n♻️ California-certified Green Business\n💪 Woman-owned biz\n⛔ Not on Amazon\n🌁 Made in San Francisco\n🎨 Designed by Christine Schmidt  \n\n***Please note the owls are hibernating from 12/24-1/5, all orders will ship in the new year!***",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:04.560Z",
    importedBy: "entity-db-cli",
  },
};
